import { MutationTree } from 'vuex';
import { StepSequencerState } from '@/store/types/step-sequencer.state';

export const mutations: MutationTree<StepSequencerState> = {
    setSelected(state, value) {
        state.selected = value;
    },
    setChords(state, value) {
        state.chords = value;
    },
    setCurrentChord(state, value) {
        state.currentChord = value;
    },
    setCurrentChordN(state, value) {
        state.currentChordN = value;
    },
    setStarted(state, value) {
        state.started = value;
    },
};
